(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bffl-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initGallery = (gallery) => {
      if (!gallery || gallery.dataset.galleryBound === 'true') return;

      const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      const dots = Array.from(gallery.querySelectorAll('[data-gallery-dot]'));
      const prev = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');

      if (!slides.length) return;
      gallery.dataset.galleryBound = 'true';

      let index = 0;
      const setActive = (nextIndex) => {
        index = ((nextIndex % slides.length) + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      };

      if (prev) prev.addEventListener('click', () => setActive(index - 1));
      if (next) next.addEventListener('click', () => setActive(index + 1));

      dots.forEach((dot) => {
        dot.addEventListener('click', () => setActive(Number(dot.dataset.index)));
      });

      document.addEventListener('shopify:block:select', (event) => {
        const blockId = event.detail && event.detail.blockId;
        if (!blockId) return;
        const match = slides.find((slide) => slide.dataset.blockId === blockId);
        if (!match) return;
        const matchedIndex = Number(match.dataset.index);
        if (!Number.isNaN(matchedIndex)) setActive(matchedIndex);
      });

      setActive(0);
    };

    const initAll = () => {
      document.querySelectorAll('[data-cta-gallery]').forEach((gallery) => initGallery(gallery));
    };

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bffl-reasons"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initReasonsTracker = (section) => {
      if (!section || section.dataset.reasonsTrackerBound === 'true') return;

      const items = Array.from(section.querySelectorAll('[data-reason-item]'));
      if (!items.length) return;

      section.dataset.reasonsTrackerBound = 'true';

      const setActive = (activeItem) => {
        items.forEach((item) => item.classList.toggle('is-active', item === activeItem));
      };
      const supportsMouseHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      const getTopLine = () => (window.matchMedia('(max-width: 989px)').matches ? 86 : 112);
      const getRootMargin = () => {
        const topLine = getTopLine();
        return `-${topLine}px 0px -55% 0px`;
      };

      const pickActiveItem = () => {
        const topLine = getTopLine();
        let closestItem = items[0];
        let closestDistance = Number.POSITIVE_INFINITY;

        for (const item of items) {
          const rect = item.getBoundingClientRect();
          const distance = Math.abs(rect.top - topLine);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestItem = item;
          }
        }

        return closestItem;
      };

      let rafId = null;
      const onScroll = () => {
        if (rafId !== null) return;
        rafId = requestAnimationFrame(() => {
          rafId = null;
          setActive(pickActiveItem());
        });
      };

      let observer = null;
      let activeByObserver = false;
      const bindObserver = () => {
        if (!('IntersectionObserver' in window)) return;
        if (observer) observer.disconnect();

        observer = new IntersectionObserver(
          (entries) => {
            const visible = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => Math.abs(a.boundingClientRect.top - getTopLine()) - Math.abs(b.boundingClientRect.top - getTopLine()));

            if (visible.length) {
              activeByObserver = true;
              setActive(visible[0].target);
            }
          },
          {
            root: null,
            rootMargin: getRootMargin(),
            threshold: 0
          }
        );

        items.forEach((item) => observer.observe(item));
      };

      bindObserver();
      window.addEventListener('scroll', () => {
        if (!activeByObserver) onScroll();
      }, { passive: true });
      window.addEventListener('resize', () => {
        activeByObserver = false;
        bindObserver();
        onScroll();
      });

      if (supportsMouseHover()) {
        let hoveredItem = null;

        const applyScrollState = () => {
          if (hoveredItem) return;
          setActive(pickActiveItem());
        };

        items.forEach((item) => {
          item.addEventListener('mouseenter', () => {
            hoveredItem = item;
            setActive(item);
          });
        });

        section.addEventListener('mouseleave', () => {
          hoveredItem = null;
          applyScrollState();
        });

        window.addEventListener('scroll', applyScrollState, { passive: true });
        window.addEventListener('resize', applyScrollState);
      }

      setActive(pickActiveItem());
    };

    const initAll = () => {
      const sections = document.querySelectorAll('.bffl-reasons[id^="bffl-reasons-"]');
      sections.forEach((section) => initReasonsTracker(section));
    };

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
